import { dom } from '@assets/js/utilities/dom.js'
import { swapRegion } from '@assets/js/utilities/html-swap.js'
import { $nav } from './js/context.js'
import { initProductSwiper, setActiveProduct } from './js/product-nav-swiper.js'
import { initContentSwipers, syncRequestedVariant } from './js/variant-swiper.js'
import { initVariantNavigation } from './js/variant-navigation.js'
import { initSpecSheet } from './js/spec-sheet.js'

const navigate = swapRegion({
    target: '#product-display-area',
    selector: '#product-display-area',
    seedHistory: true,
    onPopstate: (url) => setActiveProduct(url),
    onSuccess: ({ url, doc }) => {
        syncRequestedVariant(url)
        initContentSwipers()
        dom(document).trigger('contenido:urlChanged', { url, doc })
    }
})

initProductSwiper()
initContentSwipers()
initVariantNavigation()
initSpecSheet()

// Interceptar clics en el swiper de productos
$nav.on('click', '.product-link', (event, self) => {
    const url = self.attr('href')

    event.preventDefault()
    if (self.hasClass('is-active')) return

    setActiveProduct(url)

    navigate(url).catch((error) => {
        console.error('Fetch error:', error)
        window.location.href = url
    })
})
